import { Link, useLocation } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";
import { BUSINESS } from "@/lib/config";

/**
 * Sticky bottom action bar — always visible on mobile for one-tap Book/Call.
 * Hidden on desktop (nav has both) and on /book (the page has its own submit CTA).
 */
export default function StickyMobileBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/book")) return null;

  return (
    <div
      data-testid="sticky-mobile-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-black/90 backdrop-blur-xl pb-safe"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href={BUSINESS.phoneHref}
          data-testid="sticky-call-btn"
          className="inline-flex items-center justify-center gap-2 h-12 rounded-full border border-white/25 text-white font-medium text-sm active:scale-[0.98] transition-transform"
        >
          <Phone size={16} /> Call / Text
        </a>
        <Link
          to="/book"
          data-testid="sticky-book-btn"
          className="inline-flex items-center justify-center gap-2 h-12 rounded-full bg-otgg-red text-white font-semibold text-sm active:scale-[0.98] transition-transform"
        >
          <Calendar size={16} /> Book Now
        </Link>
      </div>
    </div>
  );
}
